export function getHeaderFontSize() {
    return (
        window['formGrid'] &&
        window['formGrid'].getHeaderFontSize &&
        window['formGrid'].getHeaderFontSize()
    );
}
